import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_SETTINGS = {
  telefon: "080 33 11",
  email: "info@hobbycenter.si",
  naslov: "Industrijska cesta 12",
  posta_kraj: "1000 Ljubljana",
  odpiralni_cas: "pon–pet 7–17h, sob 8–12h",
  obvestilo: "Brezplačna dostava nad 500 €",
  telefoni: [],
};

export function getPhoneLines(settings) {
  const lines = (settings.telefoni || []).filter((l) => l && l.stevilka);
  if (lines.length) return lines;
  if (settings.telefon) return [{ oddelek: "", stevilka: settings.telefon }];
  return [];
}

let cache = null;

export function invalidateSettingsCache() {
  cache = null;
}

export function useSettings() {
  const [settings, setSettings] = useState(cache || DEFAULT_SETTINGS);
  useEffect(() => {
    if (cache) return;
    api.get("/settings")
      .then((r) => {
        cache = { ...DEFAULT_SETTINGS, ...r.data };
        setSettings(cache);
      })
      .catch(() => {});
  }, []);
  return settings;
}
